"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var leaflet_1 = require("leaflet");
var vue2_leaflet_1 = require("vue2-leaflet");
var vue2_leaflet_vectorgrid_1 = __importDefault(require("vue2-leaflet-vectorgrid"));
var parameters_1 = __importDefault(require("@/config/parameters"));
require("leaflet/dist/leaflet.css");
var NarrativeMap = /** @class */ (function (_super) {
    __extends(NarrativeMap, _super);
    // eslint-disable-next-line max-lines-per-function
    function NarrativeMap() {
        var _this = _super.call(this) || this;
        _this.tileServerUrl = parameters_1.default.mapConfiguration.tileServerUrl;
        _this.tileServerAttribution = parameters_1.default.mapConfiguration.attribution;
        _this.locationCenter = null;
        _this.loader = true;
        _this.zoom = 10;
        _this.center = _this.findValidInitialCenter();
        _this.markerIcon = new leaflet_1.Icon({
            iconUrl: require('@/assets/images/Markers/SimpleMarker.png'),
            iconSize: [45, 45],
            iconAnchor: [22.5, 45]
        });
        _this.geojsonOptions = {
            pointToLayer: function (feature, latlng) { return new leaflet_1.Marker(latlng, { icon: _this.markerIcon }); },
            onEachFeature: function (feature, layer) {
                _this.updateLocationCenter(layer);
            }
        };
        _this.partnershipRoutesTileServer = parameters_1.default.mapConfiguration.partnershipRoutesTileServerUrl + "/" + _this.$route.params.partnershipSlug + "/{z}/{x}/{y}.pbf";
        _this.partnershipRoutesOptions = {
            interactive: true,
            maxNativeZoom: 15,
            vectorTileLayerStyles: {
                "santiagodecompostela": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
                "rome": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
                "saintolav": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
                "csiksomlyo": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
            }
        };
        return _this;
    }
    NarrativeMap.prototype.beforeMount = function () {
        this.$emit('mapLoading');
    };
    NarrativeMap.prototype.mounted = function () {
        this.$emit('mapReady');
    };
    NarrativeMap.prototype.findValidInitialCenter = function () {
        var _a, _b;
        var startingCoords = this.chapter.location.coordinates;
        while (startingCoords instanceof Array && typeof ((_a = startingCoords[0]) !== null && _a !== void 0 ? _a : null) !== "number") {
            startingCoords = ((_b = startingCoords[0]) !== null && _b !== void 0 ? _b : null);
        }
        return startingCoords.slice().reverse();
    };
    NarrativeMap.prototype.setDefaultBounds = function () {
        this.$refs.MapViewer.mapObject.flyToBounds(this.$refs.locationsGeoJSON.getBounds(), { maxZoom: 12 });
    };
    // Return the center of the locationsGeoJSON if this object is not already a point (polygon, linestring, ...)
    NarrativeMap.prototype.updateLocationCenter = function (layer) {
        var _a;
        var geometry = (layer === null || layer === void 0 ? void 0 : layer.feature).geometry;
        this.locationCenter = (_a = (geometry.type !== "Point" ? layer === null || layer === void 0 ? void 0 : layer.getBounds().getCenter() : null)) !== null && _a !== void 0 ? _a : null;
    };
    NarrativeMap.prototype.changeSizeContainer = function (value, oldValue) {
        if (value && !oldValue) {
            this.$refs.MapViewer.mapObject.invalidateSize();
            this.setDefaultBounds();
        }
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], NarrativeMap.prototype, "chapter", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], NarrativeMap.prototype, "narrative", void 0);
    __decorate([
        vue_property_decorator_1.PropSync("containerReady", { required: true })
    ], NarrativeMap.prototype, "internalContainerReady", void 0);
    __decorate([
        vue_property_decorator_1.Watch("internalContainerReady")
    ], NarrativeMap.prototype, "changeSizeContainer", null);
    NarrativeMap = __decorate([
        vue_property_decorator_1.Component({
            name: 'NarrativeMap',
            components: {
                LMap: vue2_leaflet_1.LMap,
                LTileLayer: vue2_leaflet_1.LTileLayer,
                LControlLayers: vue2_leaflet_1.LControlLayers,
                LControl: vue2_leaflet_1.LControl,
                LControlZoom: vue2_leaflet_1.LControlZoom,
                LTooltip: vue2_leaflet_1.LTooltip,
                LProtobuf: vue2_leaflet_vectorgrid_1.default,
                LPolygon: vue2_leaflet_1.LPolygon,
                LGeoJson: vue2_leaflet_1.LGeoJson,
                LMarker: vue2_leaflet_1.LMarker,
            },
        })
    ], NarrativeMap);
    return NarrativeMap;
}(vue_1.default));
exports.default = NarrativeMap;
